import _ from 'lodash'
import Routes from '../common/Routes'

export const MFA_ENROLMENT_REQUIRED = 'mfa_enrolment_required'
export const MFA_PASSWORD_LOGIN_REQUIRED = 'mfa_password_login_required'
export const MFA_SETUP_LOCATION = { pathname: Routes.profiles.edit, state: { activeIndex: 2 } }

export const mfaDenial = (error) => {
  if (_.get(error, 'response.status') !== 403) return undefined
  const key = _.get(error, 'response.data.errors[0].detail.mfa')
  return [MFA_ENROLMENT_REQUIRED, MFA_PASSWORD_LOGIN_REQUIRED].includes(key) ? key : undefined
}

export const needsMfaEnrolment = (profile) =>
  Boolean(profile) && Boolean(profile.admin) && !profile.two_fa_enabled
